import React, { FC, useState, memo } from 'react';
import { Bubble, Icon, Segment, Switch, StatusTip } from 'tea-component';
import Distribution from './Distribution';
import RetentionCurve from './RetentionCurve';
import RetentionTopList from './RetentionTopList';
import { GameSegmentType } from '../../types';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TipContext from '@/pages/home/components/TipContext';
import { useIntl } from 'umi';

import './index.scss';

const { LoadingTip } = StatusTip;

interface RetentionProps {
  loading: boolean;
  gameSegment: GameSegmentType;
  usRevenue: any[];
  retentionCurve: any[];
  arpuRetention: any[];
}

const Retention: FC<RetentionProps> = (props) => {
  const {
    loading = false,
    gameSegment,
    usRevenue,
    retentionCurve,
    arpuRetention,
  } = props;
  const { formatMessage } = useIntl();

  const segmentList = [
    {
      text: formatMessage({ id: 'dbi_benchmark_distribution' }),
      value: 'distribution',
    },
    {
      text: formatMessage({ id: 'dbi_benchmark_retention_rank_curve' }),
      value: 'retention_curve',
    },
  ];
  // GaaS Capability: ARPMAU & Retention 图segment
  const [activeSegment, setActiveSegment] = useState('distribution');
  // Put in all games 控制开关
  const [isAllGame, setIsAllGame] = useState(false);

  const handleSegmentChange = (value: string) => {
    setActiveSegment(value);
  };

  const handlePutInAllGames = (value: boolean) => {
    setIsAllGame(value);
  };

  const goHelpFAQ = ()=> {
    window.open('/help/faq/2', '_blank');
  }

  return (
    <div className="dbi-benchmark-rowbox figure-retention-container">
      <CardSlotV2
        className="dbi-benchmark-cardbox dbi-benckmark-topgame-wrapper benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({ id: 'dbi_benchmark_top_us_digital' })}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={formatMessage({
                id: 'dbi_benchmark_top_digital_revenue_info',
              })}
            />
          </>
        }
      >
        <RetentionTopList loading={loading} gameTopList={usRevenue} />
      </CardSlotV2>
      <CardSlotV2
        className="dbi-benchmark-cardbox dbi-benchmark-arpu-retention benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({ id: 'dbi_benchmark_gaas_capability' })}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={
                <div>
                  {formatMessage({
                    id: 'dbi_benchmark_gass_capability_info',
                  })}
                  <br />
                  {formatMessage(
                    {
                      id: 'dbi_benchmark_gaas_capability_faq',
                    },
                    {
                      link: <span className="dbi-benchmark-faq-link" onClick={goHelpFAQ}>FAQ</span>,
                    },
                  )}
                </div>
              }
            />
          </>
        }
      >
        {loading ? (
          <div className="retention-top-game-container-loading">
            <LoadingTip className="dbi-benchmark-chart-loading" />
          </div>
        ) : (
          <>
            <div className="arpu-retention-segment">
              <Segment
                options={segmentList}
                value={activeSegment}
                onChange={(value) => handleSegmentChange(value)}
              />
              {/* Distribution 和 后台返回的游戏列表大于20的时候 Put in all
              games才能发挥作用 */}
              {activeSegment === 'distribution' && arpuRetention?.length > 20 && (
                <span className="arpu-retention-switch">
                  <span className="arpu-retention-switch-label">
                    {formatMessage({ id: 'dbi_benchmark_put_all_games' })}
                  </span>
                  <Switch value={isAllGame} onChange={handlePutInAllGames} />
                </span>
              )}
            </div>
            {activeSegment === 'distribution' ? (
              arpuRetention?.length > 0 ? (
                <Distribution
                  gameSegment={gameSegment}
                  isAllGame={isAllGame}
                  gameList={arpuRetention}
                />
              ) : (
                <div
                  className="dbi_pc_benchmark_no_data-warp"
                  style={{ height: 430 }}
                >
                  {formatMessage({ id: 'dbi_detail_no_data_under' })}
                </div>
              )
            ) : retentionCurve?.length > 0 ? (
              <RetentionCurve gameRetentionList={retentionCurve} />
            ) : (
              <div
                className="dbi_pc_benchmark_no_data-warp"
                style={{ height: 430 }}
              >
                {formatMessage({ id: 'dbi_detail_no_data_under' })}
              </div>
            )}
          </>
        )}
      </CardSlotV2>
    </div>
  );
};

export default memo(Retention);
